import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import ReachOutToOurTeam from "./sections/ReachOutToOurTeam";
import FindUsInTheNeighborhood from "./sections/FindUsInTheNeighborhood";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <ReachOutToOurTeam />
      <FindUsInTheNeighborhood />
      <Footer />
    </div>;
}